import React from "react";
import { Card, CardBody, CardTitle, Button, CardImg } from "reactstrap";
import dealerLoyaltyImage from "assets/img/dealerLoyalty.png";

/**
 * Component for rendering an DealerLoyalty sign-up button.
 */
const DealerLoyaltyButton = () => {
	/**
	 * Opens a link to the DealerLoyalty sign-up PDF in a new tab.
	 */
	const commitData = () => {
		window.open(
			"https://dealerclick.com/DealerClick_DLP.pdf",
			"_blank",
			"noopener,noreferrer"
		);
	};

	return (
		<Card
			className="text-center mt-4 shadow-sm"
			style={{ maxWidth: "18rem", margin: "auto" }}
		>
			<CardBody>
				<div className="mb-3">
					<CardImg
						top
						width="100%"
						src={dealerLoyaltyImage}
						alt="Dealer Loyalty Logo"
						style={{ maxWidth: "100px", margin: "auto" }}
					/>
				</div>
				{/* <CardTitle tag="h5" className="mb-3">
					DealerLoyalty Sign-Up
				</CardTitle> */}
				<Button size="sm" color="primary" onClick={commitData}>
					Sign Up
				</Button>
			</CardBody>
		</Card>
	);
};

export default DealerLoyaltyButton;
